const MARKDOWN_HELP = `
# Date Formatting

Date Formatting 기능을 사용하면 **날짜 데이터를 다양한 형식으로 변환**할 수 있습니다.  
ISO 날짜, 로컬 형식, 특정 포맷을 적용하여 데이터를 변환할 수 있습니다.

## 🛠 사용 방법

1. **입력값**: 입력 데이터는 일반적으로 날짜 형식(ISO 8601, 타임스탬프 등)이어야 합니다.
2. **포맷 옵션 선택**: 다양한 포맷 옵션을 적용하여 원하는 형태로 변환할 수 있습니다.
3. **결과 반환**: 변환된 날짜 문자열이 출력됩니다.

## 📌 예제 1: ISO 형식으로 변환
\`\`\`javascript
return new Date(input).toISOString();
\`\`\`

## 📌 예제 2: YYYY-MM-DD 형식으로 변환
\`\`\`javascript
const date = new Date(input);
return date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, '0') + "-" + date.getDate().toString().padStart(2, '0');
\`\`\`

## 📌 예제 3: 로컬 날짜 형식으로 변환
\`\`\`javascript
return new Date(input).toLocaleDateString();
\`\`\`

## 📌 예제 4: UNIX 타임스탬프 변환
\`\`\`javascript
return Math.floor(new Date(input).getTime() / 1000);
\`\`\`

## 📌 지원하는 날짜 형식
- **ISO 8601** (예: \`2023-12-25T14:30:00Z\`)
- **Unix Timestamp** (예: \`1703704200\`)
- **YYYY-MM-DD** (예: \`2023-12-25\`)
- **MM/DD/YYYY** (예: \`12/25/2023\`)

## ⚠ 주의 사항
- 입력값이 유효한 날짜 형식이어야 합니다.
- 월(Month)은 **0부터 시작**하므로, 변환 시 +1을 해주어야 합니다.
- 브라우저 환경에 따라 \`toLocaleDateString()\` 결과가 다를 수 있습니다.

💡 **다양한 날짜 변환 기능을 활용하여 원하는 포맷으로 변환하세요!**
`

export const DateFormatting = {
  name: 'date-format',
  label: 'Date Formatting',
  specifications: [
    {
      type: 'text',
      name: 'format',
      label: 'Date Format'
    }
  ],
  help: MARKDOWN_HELP
}
